import React from 'react';
import './DatePicker.css';

const DatePicker = ({ value, onChange, placeholder, language = 'en' }) => {
  // Преобразуем дату из формата YYYY-MM-DD в Date объект
  const dateValue = value ? value : '';

  const handleChange = (e) => {
    const newValue = e.target.value; // Формат YYYY-MM-DD
    onChange(newValue);
  };

  return (
    <input
      type="date"
      value={dateValue}
      onChange={handleChange}
      placeholder={placeholder}
      className="date-picker-input"
      max={new Date().toISOString().split('T')[0]} // Ограничение: не позже сегодняшнего дня
      lang={language}
    />
  );
};

export default DatePicker;